import React from 'react';
import block from 'bem-cn-lite';

const b = block('RequestFormsInput');

export default ({children}) => (
    <button className={b({button: true})}>{children}</button>
)